import React, { useState, useEffect } from 'react'
import { Panel, Row } from 'rsuite'
// import ClosureDurableArticlesSearchForm from './ClosureDurableArticlesSearchForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../../constants/pathname'
import { doneLoading, startLoading } from '../../../utils/loading'
import { creatAssetCount, searchAssetCount } from '../../../redux/actions/accountingAssetClosure'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, ERR_MSG_CREATASSETCOUNT } from '../../../constants/msgText'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import AssetCountingTable from './AssetCountingTable'
import AssetCountingSupplyOfficerForm from './AssetCountingSupplyOfficerForm'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function AssetCountingWidget(props) {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result)
  const [isViewMode, setIsViewMode] = useState(props.isViewMode)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchAssetCount(request, pagenumber, pagesize)

      setDataTable(response.model)
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    console.log('searchRequest => ', !searchRequest.projectCode, searchRequest)

    // add project code to state s' searchRequest
    if (!searchRequest.projectCode) {
      searchRequest.projectCode = projectCode || ''
    }

    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  const onSelect = (request) => {
    sessionSetItemStr('initialId', request.id)

    history.push({
      pathname: `${pathname.durableArticles.AddAssetCounting}`,
    })
  }

  const handleCreatAssetCount = async () => {
    console.log('handleCreatAssetCount')

    setIsLoading(true)
    startLoading()
    try {
      // note request = {}, projectCode = '', budgetYear = 0
      const response = await creatAssetCount({}, projectCode)
      console.log('searchAssetCount ', response)

      // return false
      if (response?.model?.successed) {
        const initialId = response?.model?.id || ''
        // save to session
        sessionSetItemStr('initialId', initialId)
        history.push({
          pathname: `${pathname.durableArticles.AddAssetCounting}`,
        })
      } else {
        notification.open('error', {
          title: response?.model?.message || ERR_MSG_CREATASSETCOUNT,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={formSchema?.header || 'ตรวจนับครุภัณฑ์โครงการ'}
        bordered
      >
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {formSchema?.searchForm && (
          <div style={{ marginTop: 20 }}>
            <AssetCountingSupplyOfficerForm
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
              isSupplyOfficer={false}
            />
          </div>
        )}

        {/* {!isViewMode && ( */}
        <Row style={{ marginTop: 20, marginRight: 10, textAlign: 'right' }}>
          <SaveButton
            icon="plus-square"
            style={{ marginBottom: -10 }}
            onClick={() => {
              setIsShowConfirm(true)
              // handleCreatAssetCount()
            }}
          >
            สร้างรายการตรวจนับ
          </SaveButton>
        </Row>
        {/* )} */}

        <AssetCountingTable
          schema={dataTable}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
          isViewMode={isViewMode}
          onSelect={onSelect}
          isSupplyOfficer={false}
        />
      </Panel>

      <ConfirmWidget
        title={
          <div>
            ระบบกำลังจะสร้างรายการตรวจนับครุภัณฑ์ <br />
            ต้องการดำเนินการต่อใช่หรือไม่
          </div>
        }
        show={isShowConfirm}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => handleCreatAssetCount()}
      />
    </>
  )
}
